import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

export class StudentAttendanceSummaryCard {
	constructor(parent, student, atr) {
		[this.el, this.$] = DojoTemplates('StudentAttendanceSummaryCard');
		this.$.attendanceType.textContent = atr.AttendanceType.Name;
		this.$.attendanceCount.textContent = atr.Count;
		this.el.style.backgroundColor = atr.AttendanceType.Color;
		parent.appendChild(this.el);
	}
}